export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "harvested_exp_package": {
            "number": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Total"])},
            "crop_exp_package": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empaque"])},
            "crop_category": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Categoría"])},
            "crop_size": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Calibre"])}
          }
        }
      },
      "en": {
        "model": {
          "harvested_exp_package": {
            "number": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Number"])},
            "crop_exp_package": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Harvest package"])},
            "crop_category": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Category"])},
            "crop_size": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Size"])}
          }
        }
      }
    }
  })
}